import { Component, OnInit } from '@angular/core';

//import { TestService } from 'src/app/_services/test.service';


import { TestService } from './../../_services/test.service';


//import { SpecialityService } from './../../_services/speciality.service';

import { OrganisationsService } from 'app/_services/organisations.service';
import { FormsModule } from '@angular/forms';
import {INgxMyDpOptions, IMyDateModel} from 'ngx-mydatepicker';
import { MatSnackBar } from "@angular/material";

@Component({
  selector: 'app-testmaster',
  templateUrl: './testmaster.component.html',
  styleUrls: ['./testmaster.component.css']
})
export class TestmasterComponent implements OnInit {
  productLoading:Boolean=false
  organizationType:any
  testlist:any;
  totalRecords:any = 0;
  page=0;
  testfilter: any = {
    testname:"",
   teststatus:"Active",
   testorganisationtype:""
  };

size = 10;


constructor(private testservice:TestService,private orgservice: OrganisationsService,
  private snackBar :MatSnackBar) { }

ngOnInit() 
{

  this.getOrganizationType()
  this.gettestlist(1,this.testfilter);
}


gettestlist(page: number,testfilter){

console.log("testfilter",testfilter)

this.productLoading=true

  this.testservice.getTestlist((page - 1) ,this.size,testfilter).subscribe((response) => {
    if(response.status_code == 200){




      console.log("response",response)

      this.testlist=response.Data
      this.totalRecords=response.total_count
      this.page=page
      this.productLoading=false
    }else{
      this.testlist = [];
     
      this.totalRecords = 0 ;
      this.productLoading=false
      this.snackBar.open(response.Metadata.Message, '', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-red']
      });




    }
  },(err: any) => console.log("error",err),() =>
    console.log("getCustomersPage() retrieved customers for page:", + page)
  );
}
onSubmit() 
{
this.gettestlist(1,this.testfilter)
}


clearfilter()
{
this.testfilter.testname=""
this.testfilter.teststatus=""
this.gettestlist(1,this.testfilter)
}



pageChanged(event)
{
this.gettestlist(event,this.testfilter)
}


statuschange(testid,status)
{
this.testservice.updatestatus(testid,status)
.subscribe(
data => {
console.log("data",data);
if(data.status_code==200)
{
console.log("data",data)  
}
else
{
console.log("data",data)  
}
})
}
getOrganizationType(){
  this.orgservice.getOrganizationType().subscribe((response)=>{

console.log("response.Data",response.Data)

      this.organizationType = response.Data
  })
}



}



// WEBPACK FOOTER //
// ./src/app/component/testmaster/testmaster.component.ts